import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import TrackerManager from '../../utils/TrackerManager';
import './styles/modalReintento.scss';
import Metadata from '../../requests/apa/Metadata';
import Utils, { setRandomTimeout } from '../../utils/Utils';
import { Resilence } from 'src/AAF/Resilence/main';

const withEllipsis = (text, maxLength) => {
    if(text.length > maxLength) {
        return text.slice(0, maxLength - 3).concat("...");
    }
    return text
}
/*  - Si en props viene la propiedad errorCode y es usuario IPTV en STB, se utiliza el rediseño con un solo botón.
    - Si no viene dicha propiedad se mantienen textos anteriores y el diseño de 3 botones.
    - Actualmente el único flujo que incorpora rediseño (props.errorCode) es la modal "fallback"
    - Se realiza reintento luego de cierto tiempo aleatorio si el usuario no selecciona ningún botón (solo para modal "fallback" [props.isStartPlayFalled] */
const ModalReintento = (props) => {
    const isIPTVUser = Resilence.isPTVUSer();
    const isIptv = props.errorCode && isIPTVUser;
    const liveFallback = props.retryPlaying && props.retryPlaying.data && props.retryPlaying.data.islive ? props.retryPlaying.data.islive : false;
    const isLive = props.isLive || liveFallback;
    const iptvLive = isIptv && isLive;
    const isFallback = props.retryPlaying ? true : false;
    const isUnsupportedProvider = props.isUnsupportedProvider || false;
    const defaultAsset = Asset.get('alert_warning_generic_icon', '');
    const defaultTitle = Translator.get('retry_warning_title_label', '');
    const defaultContent = Translator.get('retry_warning_description_label', '');
    const defaultButtonTitle = Translator.get('retry_warning_option_button_retry', '');
    const messageIptv = Translator.get(props.errorCode, '');
    const messageVod = `${Translator.get('msg_modal_retry', '')}`;
    const messageLive = Translator.get(`${props.errorCode}_retry_warning_description_label`,'');
    const unsupportedProviderTitle = Translator.get('PlayerVodKaon_Falla_TextoTitulo');
    const unsupportedProviderDescription = Translator.get('PlayerVodKaon_Falla_TextoDescripcion');
    const unsupportedProviderButton = Translator.get('PlayerVodKaon_Falla_TextoBotonPrimario');
    /**
     * Se valida por tipo de reintento para mensaje y titulo
     * @var {messageFallback/tittleFallback}  se valida que sea fallback y live par usar props.errorCode(aplica para iptv y ott isFallback && isLive)
     * @var {messageReintento/tittleReintento} se valida que sea live pero no fallback para usar la llave`${props.errorCode}_retry_warning_description_label`
     * @var {messageReintentoVod/tittleReintentoVod} se valida que no sea fallback ni live para usar msg_modal_retry
     * @var {messageButton} mismo caso que arriba, se valida por tipo de reintento para mostrar el contenido del boton
     */
    const messageFallback = isFallback && iptvLive ? messageIptv : isFallback && isLive ? messageIptv : defaultContent;
    const messageReintento = !isFallback && isLive ? messageLive : defaultContent;
    const messageReintentoVod = !isFallback && !isLive ? messageVod : defaultContent;
    const tittleFallback = isFallback && iptvLive ? Translator.get(`${props.errorCode}_title`, '') : isFallback && isLive ? Translator.get(`${props.errorCode}_title`, '') : defaultTitle;
    const tittleReintento = !isFallback && isLive ? Translator.get(`${props.errorCode}_retry_warning_title_label`, '') : defaultTitle;
    const tittleReintentoVod = !isFallback && !isLive ? Translator.get('ti_modal_retry', '') : defaultTitle;
    const messageModal = 
        isFallback && isLive ? messageFallback : 
            !isFallback && isLive ? messageReintento : 
                isUnsupportedProvider ? unsupportedProviderDescription : 
                    messageReintentoVod;
    const content = 
        isUnsupportedProvider ? messageModal : 
            messageModal ? 
                withEllipsis(messageModal, 216).replace(/[.]/g, '&#46') : 
                withEllipsis(defaultContent, 216).replace(/[.]/g, '&#46');
    const title = 
        isFallback && isLive ? tittleFallback : 
            !isFallback && isLive ? tittleReintento : 
                isUnsupportedProvider ? unsupportedProviderTitle : 
                    tittleReintentoVod;
    const messageButton = 
        isFallback && isLive ? Translator.get(`${props.errorCode}_retry`, '') : 
            !isFallback && isLive ? defaultButtonTitle : 
                isUnsupportedProvider ? unsupportedProviderButton : 
                    Translator.get('btn_modal_retry', 'REINTENTAR');
    let timeoutId;
    if (props.isStartPlayFalled && isIptv) {
        const defaultTimeoutData = `{ "enable": true, "min_time_ms": 300000, "max_time_ms": 3600000,"interval_ms": 300000}`;
        const { enable, min_time_ms, max_time_ms, interval_ms } = JSON.parse(
            Metadata.get('notSupported_streaming_modal_config', defaultTimeoutData)
        );
        if (enable === true || enable === 'true')
            timeoutId = setRandomTimeout(
                () => props.handleClose(null, props.onRetry),
                min_time_ms,
                max_time_ms,
                interval_ms
            );
    }
    const ybrObject = {
        stackTrace: content,
        msg: 'api_error',
        url: props.url ? props.url : '',
    };
    // retry playing param se pone desde onResolveShowModal de AAFPlayerMain,
    // que indica un error de api al intentar playear
    if (typeof props.retryPlaying === 'object') {
        ybrObject.retryPlaying = Object.assign({}, props.retryPlaying);
    }
    const skipRetry = props.skipRetry === true;
    if (!skipRetry) TrackerManager.apiError(ybrObject);
    if (typeof props.setMetricsEvent === 'function') {
        const sendDimension = () => {
            const payload = new AnalyticsDimensionSingleton().getPayload();
            props.setMetricsEvent(payload);
            props.setMetricsEvent({ type: 'executor' });
        };
        const sendMetric = () => {
            props.setMetricsEvent({
                hitType: 'event',
                eventCategory: 'errores',
                eventAction: defaultTitle,
                eventLabel: content,
            });
            props.setMetricsEvent({ type: 'executor' });
            sendDimension();
        };
        sendMetric();
    }
    const p = {
        className: 'retry-new',
        asset: Asset.get(`${props.errorCode}_icon`, defaultAsset),
        title: title && title !== '' ? withEllipsis(title, 50) : ' ',
        content: content && content !== '' ? content : ' ',
        handleBackKey: (e) => props.handleClose(e, props.onReject),
        buttons: [
            {
                content: messageButton && messageButton !== '' ? messageButton : ' ',
                props: { onClick: (e) => props.handleClose(e, props.onRetry) },
            },
        ],
        onClose: (e) => props.handleClose(e, props.onReject),
        aafNewStyle: true,
        showLogo: true,
        buttonsAlign: 'vertical',
        timeoutId: timeoutId
    };

    return <ModalWrapper {...p} />;
};
export default withOnClose(ModalReintento);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalReintento.jsx